module.exports = __webpack_public_path__ + "static/img/products-XaaS.a5f13ca1.png";